import React, { Component } from "react";
import { Redirect } from "react-router";
import { MDBContainer, MDBCard, MDBIcon } from "mdbreact";
import API_URL from "../config";
import axios from "axios";
import * as XLSX from "xlsx";

class AdminValidarDeclaraciones extends Component {
  state = {
    anio: new Date().getFullYear().toString(),
    calendarios: [],
    calendarioSeleccionado: null,
    archivos: [],
    cargando: false,
    cargandoArchivos: false,
    filtroEstado: "TODOS",
    busqueda: "",
    pdfUrl: "",
    pdfTrabajador: null,
    pdfCargado: false,
    volverPanel: false,
    modalError: "",
    modalExito: "",
    modalNotificacion: false,
    notificandoNotif: false,
    resultadoNotificacion: null,
    // Eliminar firma
    modalEliminarFirma: false,
    trabajadorAEliminar: null,
    eliminandoFirma: false,
    cargandoExcel: false,
    paginaActual: 1,
    // Excepcion individual
    habilitandoFirma: null
  };

  getToken = function () {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem("datos")); } catch (e) { datos = null; } }
    return datos && datos[0] ? datos[0].autorizacion : "";
  };

  getDatos = function () {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem("datos")); } catch (e) { datos = null; } }
    return datos;
  };

  componentDidMount() {
    var datos = this.getDatos();
    if (datos) sessionStorage.setItem("datos", JSON.stringify(datos));
    var calPre = this.props.location.state ? this.props.location.state.calendario : null;
    if (calPre) {
      this.setState({ anio: calPre.anio || this.state.anio });
      this.seleccionarCalendario(calPre);
    } else {
      this.buscarCalendarios();
    }
  }

  buscarCalendarios = function () {
    var token = this.getToken();
    if (!token) return;
    this.setState({ cargando: true, calendarios: [], calendarioSeleccionado: null, archivos: [] });
    axios.post(API_URL + "/admin/listarcalendarios/", {
      body: JSON.stringify({ autorizacion: token, anio: this.state.anio })
    }).then(function (response) {
      this.setState({ calendarios: response.data || [], cargando: false });
    }.bind(this)).catch(function () {
      this.setState({ cargando: false });
    }.bind(this));
  };

  seleccionarCalendario = function (cal) {
    var anio = cal.anio || this.state.anio;
    var calNorm = Object.assign({}, cal, { anio: anio });
    this.setState({ calendarioSeleccionado: calNorm, cargandoArchivos: true, archivos: [], busqueda: "", pdfUrl: "", pdfTrabajador: null, pdfCargado: false });
    var doc = cal.documento;
    axios.post(API_URL + "/admin/listararchivoscompleto/", { anio: anio, documento: doc })
      .then(function (result) {
        this.setState({ archivos: result.data || [], cargandoArchivos: false });
      }.bind(this)).catch(function () {
        this.setState({ cargandoArchivos: false, modalError: "Error al cargar los archivos." });
      }.bind(this));
  };

  verPDF = function (trabajador) {
    var calSel = this.state.calendarioSeleccionado || {};
    var anio = calSel.anio || this.state.anio;
    var url = API_URL + "/recuperar/" + anio + "/" + (calSel.documento || "") + "/" + trabajador;
    this.setState({ pdfTrabajador: trabajador, pdfUrl: url + "?t=" + Date.now(), pdfCargado: false });
  };

  descargarPDF = function (trabajador) {
    var calSel = this.state.calendarioSeleccionado || {};
    var anio = calSel.anio || this.state.anio;
    var url = API_URL + "/recuperar/" + anio + "/" + (calSel.documento || "") + "/" + trabajador;
    window.open(url, "_blank");
  };

  enviarRecordatorio = function () {
    var cal = this.state.calendarioSeleccionado;
    var token = this.getToken();
    if (!cal || !token) return;
    this.setState({ modalNotificacion: false, notificandoNotif: true });
    axios.post(API_URL + "/admin/notificarrecordatorio/",
      { documento: cal.documento, anio: cal.anio, fechaFin: (cal.fechadefin || '').trim().substring(0, 10) },
      { headers: { Authorization: token } }
    ).then(function (r) {
      var data = r.data || {};
      // Normalizar respuesta no-bloqueante: enviando en background
      if (data.ok && data.iniciando) {
        data = { ok: true, enviados: data.total, total: data.total, mensaje: null };
      }
      this.setState({ notificandoNotif: false, resultadoNotificacion: data });
    }.bind(this)).catch(function () {
      this.setState({ notificandoNotif: false, resultadoNotificacion: { ok: false, error: "Error de conexión" } });
    }.bind(this));
  };

  confirmarEliminarFirma = function (trabajador) {
    this.setState({ modalEliminarFirma: true, trabajadorAEliminar: trabajador });
  };

  eliminarFirma = function () {
    var trabajador = this.state.trabajadorAEliminar;
    var cal = this.state.calendarioSeleccionado || {};
    var token = this.getToken();
    this.setState({ eliminandoFirma: true });
    axios.post(API_URL + "/admin/eliminardeclaracion/", {
      body: JSON.stringify({
        codigoTrabajador: trabajador,
        documento: cal.documento || '',
        anio: cal.anio || this.state.anio,
        autorizacion: token
      })
    }).then(function (r) {
      this.setState({ eliminandoFirma: false, modalEliminarFirma: false, trabajadorAEliminar: null });
      if (r.data && r.data.ok) {
        // Refrescar lista
        this.seleccionarCalendario(cal);
      } else {
        this.setState({ modalError: "Error al eliminar: " + (r.data && r.data.error ? r.data.error : "Error desconocido") });
      }
    }.bind(this)).catch(function () {
      this.setState({ eliminandoFirma: false, modalEliminarFirma: false, trabajadorAEliminar: null, modalError: "Error de conexión al eliminar." });
    }.bind(this));
  };

  habilitarFirma = function (trabajador) {
    var cal = this.state.calendarioSeleccionado || {};
    var token = this.getToken();
    var archivo = this.state.archivos.find(function(a){ return a.trabajador === trabajador; });
    var idDeclaracion = archivo ? archivo.idDeclaracion : null;
    if (!idDeclaracion || !token) return;
    this.setState({ habilitandoFirma: trabajador });
    axios.post(API_URL + '/admin/habilitarfirmadj/', {
      idDeclaracion: idDeclaracion,
      codigoTrabajador: trabajador,
      autorizacion: token
    }).then(function(r) {
      this.setState({ habilitandoFirma: null });
      if (r.data && r.data.ok) {
        this.setState({ modalExito: 'Acceso habilitado. El trabajador ya puede ingresar y firmar la declaración jurada.' });
        this.seleccionarCalendario(cal);
      } else { this.setState({ modalError: 'Error al habilitar: ' + ((r.data && r.data.error) || 'Error desconocido') }); }
    }.bind(this)).catch(function() {
      this.setState({ habilitandoFirma: null, modalError: 'Error de conexión al habilitar.' });
    }.bind(this));
  };

  quitarExcepcion = function (trabajador) {
    var cal = this.state.calendarioSeleccionado || {};
    var token = this.getToken();
    var archivo = this.state.archivos.find(function(a){ return a.trabajador === trabajador; });
    var idDeclaracion = archivo ? archivo.idDeclaracion : null;
    if (!idDeclaracion || !token) return;
    this.setState({ habilitandoFirma: trabajador });
    axios.post(API_URL + '/admin/quitarexcepcionfirmadj/', {
      idDeclaracion: idDeclaracion,
      codigoTrabajador: trabajador,
      autorizacion: token
    }).then(function(r) {
      this.setState({ habilitandoFirma: null });
      if (r.data && r.data.ok) {
        this.setState({ modalExito: 'Acceso individual removido. El trabajador ya no puede acceder a la declaración jurada.' });
        this.seleccionarCalendario(cal);
      } else { this.setState({ modalError: 'Error al quitar excepción: ' + ((r.data && r.data.error) || 'Error desconocido') }); }
    }.bind(this)).catch(function() {
      this.setState({ habilitandoFirma: null, modalError: 'Error de conexión.' });
    }.bind(this));
  };

  descargarReporteExcel = function () {
    var cal = this.state.calendarioSeleccionado || {};
    var archivos = this.state.archivos;
    var totalFirmados = archivos.filter(function (a) {
      return a.fechasubida && a.fechasubida.toString().trim() !== "";
    }).length;
    this._generarExcel(cal, archivos, totalFirmados);
  };

  _generarExcel = function(cal, archivos, totalFirmados) {
    var filas = [];
    filas.push(['REPORTE DE ESTADO DE FIRMAS - DECLARACIONES JURADAS']);
    filas.push(['Declaracion:', cal.documento || '']);
    filas.push(['Ano:', cal.anio || '']);
    filas.push(['Fecha generacion:', new Date().toLocaleString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })]);
    filas.push([]);
    filas.push(['RESUMEN', '', '', '', '', '', '', '', '', '']);
    filas.push(['Firmados', totalFirmados, '', 'Pendientes', archivos.length - totalFirmados, '', 'Total: ' + archivos.length]);
    filas.push([]);
    filas.push(['N°', 'Codigo Trabajador', 'DNI', 'Nombre Completo', 'Vinculo', 'Categoria', 'Regimen', 'Escuela', 'Estado', 'Fecha de Firma']);

    var firmados = archivos.filter(function (a) { return a.fechasubida && a.fechasubida.toString().trim() !== ""; });
    var pendientes = archivos.filter(function (a) { return !(a.fechasubida && a.fechasubida.toString().trim() !== ""); });
    var ordenados = firmados.concat(pendientes);

    ordenados.forEach(function (a, i) {
      var firmado = a.fechasubida && a.fechasubida.toString().trim() !== "";
      filas.push([
        i + 1,
        a.trabajador || '',
        a.dni || '',
        a.nombres || '',
        a.vinculo || '',
        a.categoria || '',
        a.regimen || '',
        a.escuela || '',
        firmado ? 'FIRMADO' : 'PENDIENTE',
        firmado ? (a.fechaFirmaDigital || a.fechasubida || '').toString().trim().substring(0, 16) : ''
      ]);
    });

    var ws = XLSX.utils.aoa_to_sheet(filas);
    ws['!cols'] = [
      { wch: 5 }, { wch: 18 }, { wch: 12 }, { wch: 42 }, { wch: 12 }, { wch: 20 }, { wch: 15 }, { wch: 40 }, { wch: 12 }, { wch: 20 }
    ];
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Estado Firmas');
    XLSX.writeFile(wb, 'ReporteEstadoFirmas_' + (cal.documento || 'DJ') + '_' + (cal.anio || '') + '.xlsx');
  };

  render() {
    var datos = this.getDatos();
    if (!datos) return <Redirect to="/" />;
    if (this.state.volverPanel) return <Redirect push={false} to={{ pathname: "/admin-declaraciones-juradas", state: { datos: datos } }} />;

    var anios = [];
    for (var a = 2022; a <= 2035; a++) anios.push(a.toString());

    var cal = this.state.calendarioSeleccionado;
    var calCerrado = cal && cal.fechadefin && (new Date(cal.fechadefin.trim().substring(0, 10) + 'T23:59:59') < new Date());

    var POR_PAG = 50;
    var termino = this.state.busqueda.trim().toLowerCase();
    var archivosFiltrados = this.state.archivos.filter(function (a) {
      if (this.state.filtroEstado === "FIRMADOS" && !(a.fechasubida && a.fechasubida.toString().trim() !== "")) return false;
      if (this.state.filtroEstado === "PENDIENTES" && (a.fechasubida && a.fechasubida.toString().trim() !== "")) return false;
      if (this.state.filtroEstado === "EXCEPCION" && !a.excepcion) return false;
      if (termino) {
        var codigo = (a.trabajador || "").toString().toLowerCase();
        var nombre = (a.nombres || "").toString().toLowerCase();
        var dni = (a.dni || "").toString().toLowerCase();
        return codigo.indexOf(termino) >= 0 || nombre.indexOf(termino) >= 0 || dni.indexOf(termino) >= 0;
      }
      return true;
    }.bind(this));
    var totalPaginas = Math.max(1, Math.ceil(archivosFiltrados.length / POR_PAG));
    var paginaActual = Math.min(this.state.paginaActual, totalPaginas);
    var archivosPagina = archivosFiltrados.slice((paginaActual - 1) * POR_PAG, paginaActual * POR_PAG);

    var totalFirmados = this.state.archivos.filter(function (a) {
      return a.fechasubida && a.fechasubida.toString().trim() !== "";
    }).length;

    return (
      <div style={{ minHeight: "calc(100vh - 4rem)", background: "#f0f2f5" }}>

        {/* ===== MODAL PDF ===== */}
        {this.state.pdfUrl && (
          <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.78)", zIndex: 9500, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
            <div style={{ background: "#fff", borderRadius: "14px", width: "90%", height: "90vh", maxWidth: "1050px", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 28px 70px rgba(0,0,0,0.5)" }}>
              <div style={{ background: "linear-gradient(135deg, #1565C0, #1976D2)", padding: "11px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                <span style={{ color: "#fff", fontWeight: "700", fontSize: "0.88rem", display: "flex", alignItems: "center", gap: "8px" }}>
                  <MDBIcon icon="file-pdf" style={{ color: "#ef9a9a" }} />
                  Declaración Jurada — Trabajador: <strong>{this.state.pdfTrabajador}</strong>
                </span>
                <div style={{ display: "flex", gap: "7px" }}>
                  <button onClick={function () { this.descargarPDF(this.state.pdfTrabajador); }.bind(this)}
                    style={{ background: "rgba(255,255,255,0.18)", color: "#fff", border: "1px solid rgba(255,255,255,0.35)", borderRadius: "7px", padding: "6px 14px", cursor: "pointer", fontSize: "0.78rem", fontWeight: "600" }}>
                    <MDBIcon icon="download" className="mr-1" />Descargar
                  </button>
                  <button onClick={function () { this.setState({ pdfUrl: "", pdfTrabajador: null, pdfCargado: false }); }.bind(this)}
                    style={{ background: "rgba(198,40,40,0.75)", color: "#fff", border: "none", borderRadius: "7px", padding: "6px 14px", cursor: "pointer", fontSize: "0.78rem", fontWeight: "600" }}>
                    <MDBIcon icon="times" className="mr-1" />Cerrar
                  </button>
                </div>
              </div>
              <div style={{ flex: 1, position: "relative", background: "#525659", overflow: "hidden" }}>
                {!this.state.pdfCargado && (
                  <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "#525659", zIndex: 1 }}>
                    <div style={{ textAlign: "center" }}>
                      <MDBIcon icon="spinner" spin size="2x" style={{ color: "#90caf9" }} />
                      <p style={{ color: "#ccc", marginTop: "12px", fontSize: "0.85rem" }}>Cargando PDF...</p>
                    </div>
                  </div>
                )}
                <iframe
                  key={this.state.pdfUrl}
                  src={this.state.pdfUrl + "#navpanes=0&toolbar=0&view=FitH"}
                  onLoad={function () { setTimeout(function () { this.setState({ pdfCargado: true }); }.bind(this), 200); }.bind(this)}
                  style={{ width: "100%", height: "100%", border: "none", opacity: this.state.pdfCargado ? 1 : 0, transition: "opacity 0.25s ease-in" }}
                  title="Visor PDF"
                />
              </div>
            </div>
          </div>
        )}

        <MDBContainer fluid className="pt-4 px-4 pb-4">

          {/* Header */}
          <MDBCard className="mb-3" style={{ borderRadius: "14px", border: "none", boxShadow: "0 2px 12px rgba(21,101,192,0.15)", overflow: "hidden" }}>
            <div style={{ background: "linear-gradient(135deg, #1565C0, #1976D2)", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "42px", height: "42px", borderRadius: "10px", background: "rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <MDBIcon icon="file-signature" style={{ color: "#fff", fontSize: "1.2rem" }} />
                </div>
                <div>
                  <div style={{ color: "#fff", fontWeight: "700", fontSize: "1.05rem" }}>Seguimiento de Declaraciones Juradas</div>
                  <div style={{ color: "rgba(255,255,255,0.75)", fontSize: "0.8rem" }}>
                    {cal ? cal.documento + " — " + cal.nombre : "Seleccione una declaración para ver los archivos firmados"}
                  </div>
                </div>
              </div>
              <button onClick={function () { this.setState({ volverPanel: true }); }.bind(this)}
                style={{ background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: "8px", padding: "8px 16px", cursor: "pointer", fontSize: "0.83rem", fontWeight: "600" }}>
                <MDBIcon icon="arrow-left" className="mr-2" />Declaraciones Juradas
              </button>
            </div>
          </MDBCard>

          {/* VISTA 1: Lista de calendarios */}
          {!cal && (
            <MDBCard style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", overflow: "hidden" }}>
              <div style={{ background: "linear-gradient(135deg, #37474f, #546e7a)", padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <MDBIcon icon="calendar-alt" style={{ color: "#fff" }} />
                  <span style={{ color: "#fff", fontWeight: "700", fontSize: "0.9rem" }}>Calendarios</span>
                  <span style={{ background: "rgba(255,255,255,0.2)", color: "#fff", borderRadius: "12px", padding: "2px 10px", fontSize: "0.75rem" }}>{this.state.calendarios.length}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <select value={this.state.anio} onChange={function (e) { this.setState({ anio: e.target.value }, this.buscarCalendarios.bind(this)); }.bind(this)}
                    style={{ padding: "5px 10px", borderRadius: "6px", border: "none", fontSize: "0.83rem", cursor: "pointer" }}>
                    {anios.map(function (a) { return <option key={a} value={a}>{a}</option>; })}
                  </select>
                  <button onClick={this.buscarCalendarios.bind(this)} disabled={this.state.cargando}
                    style={{ background: "#1565C0", color: "#fff", border: "none", borderRadius: "6px", padding: "6px 16px", cursor: "pointer", fontSize: "0.82rem", fontWeight: "600" }}>
                    <MDBIcon icon={this.state.cargando ? "spinner" : "sync"} className="mr-1" spin={this.state.cargando} />
                    {this.state.cargando ? "Cargando..." : "Actualizar"}
                  </button>
                </div>
              </div>
              <div style={{ overflowX: "auto" }}>
                {this.state.cargando ? (
                  <div style={{ textAlign: "center", padding: "40px", color: "#aaa" }}>
                    <MDBIcon icon="spinner" spin size="2x" style={{ color: "#1565C0" }} />
                    <p style={{ marginTop: "10px", fontSize: "0.9rem" }}>Cargando calendarios...</p>
                  </div>
                ) : this.state.calendarios.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "40px", color: "#aaa", fontSize: "0.9rem" }}>
                    <MDBIcon icon="calendar-times" size="2x" style={{ color: "#ddd", display: "block", marginBottom: "8px" }} />
                    No hay calendarios para el año {this.state.anio}
                  </div>
                ) : (
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.83rem" }}>
                    <thead>
                      <tr style={{ background: "#f8f9fa", borderBottom: "2px solid #e9ecef" }}>
                        <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555" }}>Codigo</th>
                        <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555" }}>Nombre</th>
                        <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>Fecha Inicio</th>
                        <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>Fecha Fin</th>
                        <th style={{ padding: "12px 16px", fontWeight: "700", color: "#555", textAlign: "center" }}>Accion</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.calendarios.map(function (c, i) {
                        return (
                          <tr key={i} style={{ borderBottom: "1px solid #f0f0f0", background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                            <td style={{ padding: "11px 16px", fontWeight: "700", color: "#333" }}>
                              <MDBIcon icon="tag" className="mr-1" style={{ color: "#1565C0", fontSize: "0.75rem" }} />
                              {c.documento}
                            </td>
                            <td style={{ padding: "11px 16px", color: "#444", maxWidth: "280px" }}>{c.nombre}</td>
                            <td style={{ padding: "11px 16px", color: "#555", fontSize: "0.8rem", whiteSpace: "nowrap" }}>{c.fechadeinicio ? c.fechadeinicio.trim().substring(0, 16) : "-"}</td>
                            <td style={{ padding: "11px 16px", color: "#555", fontSize: "0.8rem", whiteSpace: "nowrap" }}>{c.fechadefin ? c.fechadefin.trim().substring(0, 16) : "-"}</td>
                            <td style={{ padding: "11px 16px", textAlign: "center" }}>
                              <button onClick={function () { this.seleccionarCalendario(c); }.bind(this)}
                                style={{ background: "#1565C0", color: "#fff", border: "none", borderRadius: "7px", padding: "6px 18px", cursor: "pointer", fontSize: "0.78rem", fontWeight: "600" }}>
                                <MDBIcon icon="folder-open" className="mr-1" />Ver Archivos
                              </button>
                            </td>
                          </tr>
                        );
                      }.bind(this))}
                    </tbody>
                  </table>
                )}
              </div>
            </MDBCard>
          )}

          {/* VISTA 2: Archivos del calendario seleccionado */}
          {cal && (
            <div>
              {/* Resumen */}
              <div style={{ display: "flex", gap: "10px", marginBottom: "12px", flexWrap: "wrap" }}>
                {[
                  { icon: "pen-nib", bg: "#e8f5e9", color: "#2E7D32", val: totalFirmados, lbl: "Firmados" },
                  { icon: "clock", bg: "#fff8e1", color: "#F57C00", val: this.state.archivos.length - totalFirmados, lbl: "Pendientes" },
                  { icon: "users", bg: "#e3f2fd", color: "#1565C0", val: this.state.archivos.length, lbl: "Total" }
                ].map(function (s, i) {
                  return (
                    <div key={i} style={{ background: "#fff", borderRadius: "10px", padding: "12px 20px", boxShadow: "0 1px 6px rgba(0,0,0,0.07)", display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: "130px" }}>
                      <div style={{ width: "36px", height: "36px", borderRadius: "8px", background: s.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <MDBIcon icon={s.icon} style={{ color: s.color, fontSize: "1rem" }} />
                      </div>
                      <div>
                        <div style={{ fontSize: "1.3rem", fontWeight: "800", color: s.color, lineHeight: 1 }}>{s.val}</div>
                        <div style={{ fontSize: "0.73rem", color: "#888" }}>{s.lbl}</div>
                      </div>
                    </div>
                  );
                }.bind(this))}
              </div>

              {/* Barra de acciones */}
              {this.state.archivos.length > 0 && (
                <div style={{ marginBottom: "12px", display: "flex", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
                  <button
                    onClick={this.descargarReporteExcel.bind(this)}
                    style={{ background: "#1B5E20", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 20px", cursor: "pointer", fontSize: "0.83rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "7px" }}
                  >
                    <MDBIcon icon="file-excel" />Descargar Reporte Excel
                  </button>
                  {(this.state.archivos.length - totalFirmados) > 0 && (
                    <button
                      onClick={function () { this.setState({ modalNotificacion: true }); }.bind(this)}
                      disabled={this.state.notificandoNotif}
                      style={{ background: this.state.notificandoNotif ? "#aaa" : "#E65100", color: "#fff", border: "none", borderRadius: "8px", padding: "9px 20px", cursor: this.state.notificandoNotif ? "default" : "pointer", fontSize: "0.83rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "7px" }}
                    >
                      <MDBIcon icon={this.state.notificandoNotif ? "spinner" : "bell"} spin={this.state.notificandoNotif} />
                      {this.state.notificandoNotif ? "Enviando..." : "Notificar pendientes (" + (this.state.archivos.length - totalFirmados) + ")"}
                    </button>
                  )}
                </div>
              )}

              {/* Tabla de archivos */}
              <MDBCard style={{ borderRadius: "12px", border: "none", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", overflow: "hidden" }}>
                <div style={{ background: "linear-gradient(135deg, #37474f, #546e7a)", padding: "10px 16px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px", flexWrap: "wrap" }}>
                    <MDBIcon icon="inbox" style={{ color: "#fff" }} />
                    <span style={{ color: "#fff", fontWeight: "700", fontSize: "0.9rem" }}>Declaraciones</span>
                    {termino && (
                      <span style={{ background: "rgba(255,255,255,0.25)", color: "#fff", borderRadius: "10px", padding: "2px 8px", fontSize: "0.72rem", fontWeight: "600" }}>
                        {archivosFiltrados.length} resultado{archivosFiltrados.length !== 1 ? "s" : ""}
                      </span>
                    )}
                    <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "7px" }}>
                      <select value={this.state.filtroEstado} onChange={function (e) { this.setState({ filtroEstado: e.target.value, paginaActual: 1 }); }.bind(this)}
                        style={{ padding: "4px 8px", borderRadius: "6px", border: "none", fontSize: "0.78rem", cursor: "pointer" }}>
                        <option value="TODOS">Todos</option>
                        <option value="FIRMADOS">Firmados</option>
                        <option value="PENDIENTES">Pendientes</option>
                        <option value="EXCEPCION">Acceso excepcional</option>
                      </select>
                      <button onClick={function () { this.seleccionarCalendario(cal); }.bind(this)}
                        style={{ background: "rgba(255,255,255,0.2)", color: "#fff", border: "1px solid rgba(255,255,255,0.4)", borderRadius: "6px", padding: "5px 12px", cursor: "pointer", fontSize: "0.78rem", whiteSpace: "nowrap" }}>
                        <MDBIcon icon="sync" className="mr-1" />Actualizar
                      </button>
                    </div>
                  </div>
                  <div style={{ position: "relative" }}>
                    <MDBIcon icon="search" style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#90a4ae", fontSize: "0.85rem", pointerEvents: "none" }} />
                    <input
                      type="text"
                      placeholder="Buscar por DNI, código trabajador o nombre completo..."
                      value={this.state.busqueda}
                      onChange={function (e) { this.setState({ busqueda: e.target.value, paginaActual: 1 }); }.bind(this)}
                      style={{ width: "100%", padding: "7px 34px 7px 32px", borderRadius: "8px", border: "none", fontSize: "0.82rem", outline: "none", background: "rgba(255,255,255,0.95)", color: "#333" }}
                    />
                    {this.state.busqueda && (
                      <button
                        onClick={function () { this.setState({ busqueda: "" }); }.bind(this)}
                        style={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#90a4ae", fontSize: "0.85rem", padding: "0", lineHeight: 1 }}
                      >
                        <MDBIcon icon="times" />
                      </button>
                    )}
                  </div>
                </div>
                <div style={{ overflowX: "auto" }}>
                  {this.state.cargandoArchivos ? (
                    <div style={{ textAlign: "center", padding: "40px", color: "#aaa" }}>
                      <MDBIcon icon="spinner" spin size="2x" style={{ color: "#1565C0" }} />
                      <p style={{ marginTop: "10px", fontSize: "0.9rem" }}>Cargando archivos...</p>
                    </div>
                  ) : archivosFiltrados.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px", color: "#aaa", fontSize: "0.9rem" }}>
                      <MDBIcon icon="folder-open" size="2x" style={{ color: "#ddd", display: "block", marginBottom: "8px" }} />
                      No hay registros para mostrar
                    </div>
                  ) : (
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.8rem" }}>
                      <thead>
                        <tr style={{ background: "#f5f7fa", borderBottom: "2px solid #e4e8ed" }}>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>Cód.</th>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>DNI</th>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555" }}>Nombres</th>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>Vínculo</th>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555" }}>Categoría / Régimen</th>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555" }}>Escuela</th>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555", textAlign: "center" }}>Estado</th>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555", whiteSpace: "nowrap" }}>Fecha Firma</th>
                          <th style={{ padding: "9px 12px", fontWeight: "700", color: "#555", textAlign: "center" }}>Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {archivosPagina.map(function (a, i) {
                          var firmado = a.fechasubida && a.fechasubida.toString().trim() !== "";
                          return (
                            <tr key={i} style={{ borderBottom: "1px solid #f0f2f5", background: i % 2 === 0 ? "#fff" : "#fafbfc" }}>
                              <td style={{ padding: "8px 12px", fontWeight: "700", color: "#1565C0", fontSize: "0.78rem", whiteSpace: "nowrap" }}>{a.trabajador}</td>
                              <td style={{ padding: "8px 12px", color: "#555", fontSize: "0.78rem", whiteSpace: "nowrap", fontFamily: "monospace" }}>{a.dni || "—"}</td>
                              <td style={{ padding: "8px 12px", color: "#333", fontSize: "0.79rem" }}>{a.nombres}</td>
                              <td style={{ padding: "8px 12px", whiteSpace: "nowrap" }}>
                                {a.vinculo ? (
                                  <span style={{ background: "#ede7f6", color: "#4527a0", borderRadius: "10px", padding: "2px 9px", fontSize: "0.68rem", fontWeight: "700", letterSpacing: "0.03em" }}>
                                    {a.vinculo}
                                  </span>
                                ) : <span style={{ color: "#bbb", fontSize: "0.75rem" }}>—</span>}
                              </td>
                              <td style={{ padding: "8px 12px", minWidth: "140px" }}>
                                {a.categoria ? (
                                  <div>
                                    <div style={{ fontSize: "0.76rem", fontWeight: "600", color: "#333" }}>{a.categoria}</div>
                                    {a.regimen && <div style={{ fontSize: "0.7rem", color: "#777", marginTop: "2px" }}>{a.regimen}</div>}
                                  </div>
                                ) : <span style={{ color: "#bbb", fontSize: "0.75rem" }}>—</span>}
                              </td>
                              <td style={{ padding: "8px 12px", maxWidth: "190px" }} title={a.escuela || ""}>
                                <div style={{ fontSize: "0.74rem", color: "#444", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                  {a.escuela || <span style={{ color: "#bbb" }}>—</span>}
                                </div>
                              </td>
                              <td style={{ padding: "8px 12px", textAlign: "center" }}>
                                {firmado ? (
                                  <span style={{ background: "#e8f5e9", color: "#2E7D32", padding: "3px 10px", borderRadius: "20px", fontSize: "0.7rem", fontWeight: "700", whiteSpace: "nowrap" }}>
                                    <MDBIcon icon="pen-nib" className="mr-1" />Firmado
                                  </span>
                                ) : (
                                  <div>
                                    <span style={{ background: "#fff8e1", color: "#F57C00", padding: "3px 10px", borderRadius: "20px", fontSize: "0.7rem", fontWeight: "700", whiteSpace: "nowrap" }}>
                                      <MDBIcon icon="clock" className="mr-1" />Pendiente
                                    </span>
                                    {a.excepcion && (
                                      <div style={{ marginTop: "3px" }}>
                                        <span style={{ background: "#e3f2fd", color: "#1565C0", padding: "2px 7px", borderRadius: "10px", fontSize: "0.64rem", fontWeight: "700", whiteSpace: "nowrap" }}>
                                          <MDBIcon icon="unlock-alt" className="mr-1" />Acceso habilitado
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </td>
                              <td style={{ padding: "8px 12px", color: "#555", fontSize: "0.74rem", whiteSpace: "nowrap" }}>
                                {firmado ? (a.fechaFirmaDigital || a.fechasubida || "").toString().trim().substring(0, 16) || "—" : "—"}
                              </td>
                              <td style={{ padding: "8px 10px", textAlign: "center", whiteSpace: "nowrap" }}>
                                {firmado ? (
                                  <span style={{ display: "inline-flex", gap: "5px", flexWrap: "wrap" }}>
                                    <button onClick={function () { this.verPDF(a.trabajador); }.bind(this)}
                                      title="Ver PDF"
                                      style={{ background: "#e3f2fd", color: "#1565C0", border: "1px solid #90caf9", borderRadius: "5px", padding: "4px 9px", cursor: "pointer", fontSize: "0.75rem" }}>
                                      <MDBIcon icon="eye" />
                                    </button>
                                    <button onClick={function () { this.descargarPDF(a.trabajador); }.bind(this)}
                                      title="Descargar PDF"
                                      style={{ background: "#e8f5e9", color: "#2E7D32", border: "1px solid #a5d6a7", borderRadius: "5px", padding: "4px 9px", cursor: "pointer", fontSize: "0.75rem" }}>
                                      <MDBIcon icon="download" />
                                    </button>
                                    <button onClick={function () { this.confirmarEliminarFirma(a.trabajador); }.bind(this)}
                                      title="Eliminar firma"
                                      style={{ background: "#fdecea", color: "#C62828", border: "1px solid #ef9a9a", borderRadius: "5px", padding: "4px 9px", cursor: "pointer", fontSize: "0.75rem" }}>
                                      <MDBIcon icon="trash" />
                                    </button>
                                    {a.excepcion && (
                                      <button
                                        onClick={function () { this.quitarExcepcion(a.trabajador); }.bind(this)}
                                        disabled={this.state.habilitandoFirma === a.trabajador}
                                        title="Quitar acceso individual"
                                        style={{ background: "#fff8e1", color: "#E65100", border: "1px solid #ffcc80", borderRadius: "5px", padding: "4px 9px", cursor: "pointer", fontSize: "0.72rem", fontWeight: "600", whiteSpace: "nowrap" }}>
                                        {this.state.habilitandoFirma === a.trabajador
                                          ? <MDBIcon icon="spinner" spin />
                                          : <><MDBIcon icon="lock" className="mr-1" />Quitar acceso</>}
                                      </button>
                                    )}
                                  </span>
                                ) : calCerrado ? (
                                  a.excepcion ? (
                                    <button
                                      onClick={function () { this.quitarExcepcion(a.trabajador); }.bind(this)}
                                      disabled={this.state.habilitandoFirma === a.trabajador}
                                      title="Quitar acceso individual"
                                      style={{ background: "#fff8e1", color: "#E65100", border: "1px solid #ffcc80", borderRadius: "6px", padding: "4px 10px", cursor: "pointer", fontSize: "0.72rem", fontWeight: "600", whiteSpace: "nowrap" }}>
                                      {this.state.habilitandoFirma === a.trabajador
                                        ? <MDBIcon icon="spinner" spin />
                                        : <><MDBIcon icon="lock" className="mr-1" />Quitar acceso</>}
                                    </button>
                                  ) : (
                                    <button
                                      onClick={function () { this.habilitarFirma(a.trabajador); }.bind(this)}
                                      disabled={this.state.habilitandoFirma === a.trabajador}
                                      title="Habilitar firma individual"
                                      style={{ background: "#e8f5e9", color: "#2E7D32", border: "1px solid #a5d6a7", borderRadius: "6px", padding: "4px 10px", cursor: "pointer", fontSize: "0.72rem", fontWeight: "600", whiteSpace: "nowrap" }}>
                                      {this.state.habilitandoFirma === a.trabajador
                                        ? <MDBIcon icon="spinner" spin />
                                        : <><MDBIcon icon="unlock-alt" className="mr-1" />Habilitar</>}
                                    </button>
                                  )
                                ) : (
                                  <span style={{ fontSize: "0.72rem", color: "#ccc" }}>—</span>
                                )}
                              </td>
                            </tr>
                          );
                        }.bind(this))}
                      </tbody>
                    </table>
                  )}
                </div>
                {/* Paginación */}
                {totalPaginas > 1 && (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", borderTop: "1px solid #f0f0f0", background: "#fafafa", fontSize: "0.8rem", color: "#555" }}>
                    <span>
                      Mostrando <strong>{(paginaActual - 1) * POR_PAG + 1}–{Math.min(paginaActual * POR_PAG, archivosFiltrados.length)}</strong> de <strong>{archivosFiltrados.length}</strong> registros
                    </span>
                    <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                      <button onClick={function () { this.setState({ paginaActual: 1 }); }.bind(this)} disabled={paginaActual === 1}
                        style={{ padding: "4px 8px", border: "1px solid #ddd", borderRadius: "5px", background: paginaActual === 1 ? "#f5f5f5" : "#fff", color: paginaActual === 1 ? "#bbb" : "#333", cursor: paginaActual === 1 ? "default" : "pointer", fontSize: "0.78rem" }}>«</button>
                      <button onClick={function () { this.setState({ paginaActual: paginaActual - 1 }); }.bind(this)} disabled={paginaActual === 1}
                        style={{ padding: "4px 10px", border: "1px solid #ddd", borderRadius: "5px", background: paginaActual === 1 ? "#f5f5f5" : "#fff", color: paginaActual === 1 ? "#bbb" : "#333", cursor: paginaActual === 1 ? "default" : "pointer", fontSize: "0.78rem" }}>‹</button>
                      {Array.from({ length: totalPaginas }, function (_, i) { return i + 1; })
                        .filter(function (p) { return p === 1 || p === totalPaginas || Math.abs(p - paginaActual) <= 2; })
                        .reduce(function (acc, p, idx, arr) {
                          if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
                          acc.push(p);
                          return acc;
                        }, [])
                        .map(function (p, idx) {
                          if (p === '...') return <span key={'e' + idx} style={{ padding: "0 4px", color: "#aaa" }}>…</span>;
                          return (
                            <button key={p} onClick={function () { this.setState({ paginaActual: p }); }.bind(this)}
                              style={{ padding: "4px 9px", border: "1px solid " + (p === paginaActual ? "#1565C0" : "#ddd"), borderRadius: "5px", background: p === paginaActual ? "#1565C0" : "#fff", color: p === paginaActual ? "#fff" : "#333", cursor: "pointer", fontWeight: p === paginaActual ? "700" : "400", fontSize: "0.78rem" }}>
                              {p}
                            </button>
                          );
                        }.bind(this))}
                      <button onClick={function () { this.setState({ paginaActual: paginaActual + 1 }); }.bind(this)} disabled={paginaActual === totalPaginas}
                        style={{ padding: "4px 10px", border: "1px solid #ddd", borderRadius: "5px", background: paginaActual === totalPaginas ? "#f5f5f5" : "#fff", color: paginaActual === totalPaginas ? "#bbb" : "#333", cursor: paginaActual === totalPaginas ? "default" : "pointer", fontSize: "0.78rem" }}>›</button>
                      <button onClick={function () { this.setState({ paginaActual: totalPaginas }); }.bind(this)} disabled={paginaActual === totalPaginas}
                        style={{ padding: "4px 8px", border: "1px solid #ddd", borderRadius: "5px", background: paginaActual === totalPaginas ? "#f5f5f5" : "#fff", color: paginaActual === totalPaginas ? "#bbb" : "#333", cursor: paginaActual === totalPaginas ? "default" : "pointer", fontSize: "0.78rem" }}>»</button>
                    </div>
                  </div>
                )}
              </MDBCard>
            </div>
          )}

        </MDBContainer>

        {this.state.modalExito && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 40px", maxWidth: "420px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              <MDBIcon icon="check-circle" size="3x" style={{ color: "#2E7D32", marginBottom: "12px" }} />
              <p style={{ fontSize: "1rem", fontWeight: "700", color: "#2E7D32", marginBottom: "20px" }}>{this.state.modalExito}</p>
              <button onClick={function () { this.setState({ modalExito: "" }); }.bind(this)}
                style={{ background: "#2E7D32", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 40px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                Aceptar
              </button>
            </div>
          </div>
        )}

        {this.state.modalError && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 40px", maxWidth: "400px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              <MDBIcon icon="exclamation-triangle" size="3x" style={{ color: "#C62828", marginBottom: "12px" }} />
              <p style={{ fontSize: "1rem", fontWeight: "700", color: "#C62828", marginBottom: "20px" }}>{this.state.modalError}</p>
              <button onClick={function () { this.setState({ modalError: "" }); }.bind(this)}
                style={{ background: "#7A1622", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 40px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                Cerrar
              </button>
            </div>
          </div>
        )}

        {/* Modal confirmacion notificacion */}
        {this.state.modalNotificacion && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 36px", maxWidth: "460px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#fff3e0", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <MDBIcon icon="bell" style={{ color: "#E65100", fontSize: "2rem" }} />
              </div>
              <p style={{ fontSize: "1rem", fontWeight: "700", color: "#333", marginBottom: "6px" }}>Confirmar envio de recordatorio</p>
              <p style={{ fontSize: "0.82rem", color: "#777", marginBottom: "18px" }}>
                {(this.state.calendarioSeleccionado || {}).documento} — {(this.state.calendarioSeleccionado || {}).anio || this.state.anio}
              </p>
              <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginBottom: "20px" }}>
                <div style={{ flex: 1, background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "10px", padding: "14px 10px" }}>
                  <div style={{ fontSize: "2rem", fontWeight: "800", color: "#2E7D32", lineHeight: 1 }}>{totalFirmados}</div>
                  <div style={{ fontSize: "0.75rem", color: "#2E7D32", fontWeight: "600", marginTop: "4px" }}>
                    <MDBIcon icon="check-circle" className="mr-1" />Ya firmaron
                  </div>
                </div>
                <div style={{ flex: 1, background: "#fff3e0", border: "1px solid #ffcc80", borderRadius: "10px", padding: "14px 10px" }}>
                  <div style={{ fontSize: "2rem", fontWeight: "800", color: "#E65100", lineHeight: 1 }}>{this.state.archivos.length - totalFirmados}</div>
                  <div style={{ fontSize: "0.75rem", color: "#E65100", fontWeight: "600", marginTop: "4px" }}>
                    <MDBIcon icon="clock" className="mr-1" />Pendientes
                  </div>
                </div>
                <div style={{ flex: 1, background: "#f5f5f5", border: "1px solid #e0e0e0", borderRadius: "10px", padding: "14px 10px" }}>
                  <div style={{ fontSize: "2rem", fontWeight: "800", color: "#555", lineHeight: 1 }}>{this.state.archivos.length}</div>
                  <div style={{ fontSize: "0.75rem", color: "#555", fontWeight: "600", marginTop: "4px" }}>
                    <MDBIcon icon="users" className="mr-1" />Total
                  </div>
                </div>
              </div>
              <p style={{ fontSize: "0.87rem", color: "#555", marginBottom: "20px" }}>
                Se enviara un recordatorio por correo a los <strong style={{ color: "#E65100" }}>{this.state.archivos.length - totalFirmados} trabajadores</strong> que aun no firmaron.
              </p>
              <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                <button
                  onClick={function () { this.setState({ modalNotificacion: false }); }.bind(this)}
                  style={{ background: "#fff", color: "#666", border: "1px solid #ccc", borderRadius: "8px", padding: "10px 28px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                  Cancelar
                </button>
                <button
                  onClick={this.enviarRecordatorio.bind(this)}
                  style={{ background: "#E65100", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 28px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                  <MDBIcon icon="paper-plane" className="mr-2" />Enviar Recordatorio
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal confirmación eliminar firma */}
        {this.state.modalEliminarFirma && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.55)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 36px", maxWidth: "460px", width: "92%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.3)" }}>
              <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#fdecea", margin: "0 auto 18px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <MDBIcon icon="trash-alt" style={{ color: "#C62828", fontSize: "2rem" }} />
              </div>
              <p style={{ fontSize: "1.1rem", fontWeight: "700", color: "#C62828", marginBottom: "10px" }}>¿Eliminar registro de firma?</p>
              <p style={{ fontSize: "0.9rem", color: "#555", marginBottom: "6px" }}>
                Trabajador código: <strong style={{ color: "#333" }}>{this.state.trabajadorAEliminar}</strong>
              </p>
              <p style={{ fontSize: "0.85rem", color: "#777", marginBottom: "22px" }}>
                Se eliminará el registro en la base de datos y el archivo PDF del servidor.<br />
                El trabajador aparecerá como <strong style={{ color: "#F57C00" }}>Pendiente</strong> y deberá firmar nuevamente.
              </p>
              <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                <button
                  onClick={this.eliminarFirma.bind(this)}
                  disabled={this.state.eliminandoFirma}
                  style={{ background: this.state.eliminandoFirma ? "#aaa" : "#C62828", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 28px", cursor: this.state.eliminandoFirma ? "default" : "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                  {this.state.eliminandoFirma ? <><MDBIcon icon="spinner" spin className="mr-2" />Eliminando...</> : <><MDBIcon icon="trash" className="mr-2" />Sí, eliminar</>}
                </button>
                <button
                  onClick={function () { this.setState({ modalEliminarFirma: false, trabajadorAEliminar: null }); }.bind(this)}
                  disabled={this.state.eliminandoFirma}
                  style={{ background: "#fff", color: "#666", border: "1px solid #ccc", borderRadius: "8px", padding: "10px 28px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                  <MDBIcon icon="times" className="mr-2" />Cancelar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal resultado notificacion */}
        {this.state.resultadoNotificacion && (
          <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "32px 40px", maxWidth: "420px", width: "90%", textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,0.25)" }}>
              {this.state.resultadoNotificacion.ok ? (
                <>
                  <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#fff3e0", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <MDBIcon icon="bell" style={{ color: "#E65100", fontSize: "2rem" }} />
                  </div>
                  {this.state.resultadoNotificacion.enviados === 0 ? (
                    <p style={{ fontSize: "1rem", fontWeight: "700", color: "#2E7D32", marginBottom: "20px" }}>
                      <MDBIcon icon="check-circle" className="mr-2" />
                      {this.state.resultadoNotificacion.mensaje || "Todos los trabajadores ya firmaron su declaracion."}
                    </p>
                  ) : (
                    <p style={{ fontSize: "1rem", fontWeight: "700", color: "#E65100", marginBottom: "20px" }}>
                      Recordatorio enviado a <span style={{ fontSize: "1.4rem" }}>{this.state.resultadoNotificacion.enviados}</span> de {this.state.resultadoNotificacion.total} trabajadores pendientes.
                    </p>
                  )}
                </>
              ) : (
                <>
                  <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: "#fdecea", margin: "0 auto 16px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <MDBIcon icon="exclamation-triangle" style={{ color: "#C62828", fontSize: "2rem" }} />
                  </div>
                  <p style={{ fontSize: "1rem", fontWeight: "700", color: "#C62828", marginBottom: "20px" }}>
                    Error al enviar: {this.state.resultadoNotificacion.error || "Error desconocido"}
                  </p>
                </>
              )}
              <button
                onClick={function () { this.setState({ resultadoNotificacion: null }); }.bind(this)}
                style={{ background: "#1565C0", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 40px", cursor: "pointer", fontSize: "0.9rem", fontWeight: "600" }}>
                Cerrar
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default AdminValidarDeclaraciones;
